import { render, staticRenderFns } from "./IntroCard.vue?vue&type=template&id=31cb3844&scoped=true&lang=pug"
import script from "./IntroCard.vue?vue&type=script&lang=js"
export * from "./IntroCard.vue?vue&type=script&lang=js"
import style0 from "./IntroCard.vue?vue&type=style&index=0&id=31cb3844&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cb3844",
  null
  
)

export default component.exports